import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-allSelect",
  "use": "icon-allSelect-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-allSelect\">\n<rect x=\"0.5\" y=\"0.5\" width=\"23\" height=\"23\" rx=\"1.5\" fill=\"#1677FF\" stroke=\"#1677FF\" />\n<path d=\"M3.75 12.9446C3.75 12.9446 8.01628 16.4249 8.44006 19.3848C8.44006 19.3848 14.0342 10.2521 20.25 9.43501C20.25 9.43501 18.357 8.05923 18.9786 5.88477C18.9786 5.88477 15.5317 6.22777 9.03339 16.2868L5.98782 11.1311L3.75 12.9446Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol